if (!customElements.get('video-media')) {
    const onYouTubePromise = new Promise((resolve) => {
  window.onYouTubeIframeAPIReady = () => resolve();
});

function visibleMedia(media) {
  return Array.from(media).find((item) => {
    const style = window.getComputedStyle(item);
    return style.display !== 'none';
  });
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
  });

  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"getPaused"}', '*');
  });

  window.addEventListener('message', (event) => {
    if (event.origin.includes('youtube.com')) {
      try {
        const data = JSON.parse(event.data);
        if (data.event === 'infoDelivery' && data.info && data.info.playerState !== undefined) {
          const playerState = data.info.playerState;
          const video = event.source.frameElement;
          if (playerState === 1) {
            video.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
            video.classList.add('paused');
          }
        }
      } catch (error) {
        console.error('Error parsing YouTube response:', error);
      }
    }

    if (event.origin.includes('vimeo.com')) {
      try {
        const data = JSON.parse(event.data);
        if (data.method === 'getPaused') {
          const video = event.source.frameElement;
          if (video && !data.value) {
            video.contentWindow.postMessage('{"method":"pause"}', '*');
            video.classList.add('paused');
          }
        }
      } catch (error) {
        console.error('Error parsing Vimeo response:', error);
      }
    }
  });

  document.querySelectorAll('video').forEach((video) => {
    if (!video.paused && !video.ended) {
      video.pause();
      video.classList.add('paused');
    }
  });

  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI && model.modelViewerUI.isPaused) {
      model.modelViewerUI.play();
      model.classList.add('paused');
    }
  });
}
	customElements.define(
    'video-media',
    class VideoMedia extends HTMLElement {
    	constructor() {
		    super();
		    this.onPosterClick = this.onPosterClick.bind(this);
		    this.togglePlayPause = this.togglePlayPause.bind(this);
		    this.toggleSound = this.toggleSound.bind(this);
		  }

		  connectedCallback() {
		    this.posterElement?.addEventListener('click', this.onPosterClick);
		    this.controlElement?.addEventListener('click', this.togglePlayPause);
		    this.soundElement?.addEventListener('click', this.toggleSound);

		    this.createObserver({
		      element: this,
		      callback: this.init.bind(this),
		      threshold: 0
		    });
		  }

		  disconnectedCallback() {
		    this.posterElement?.removeEventListener('click', this.onPosterClick);
		    this.controlElement?.removeEventListener('click', this.togglePlayPause);
		    this.soundElement?.removeEventListener('click', this.toggleSound);
		  }

		  static get observedAttributes() {
		    return ['playing', 'muted']
		  }

		  get autoplay() {
		    return this.hasAttribute('autoplay')
		  }

		  get playing() {
		    return this.hasAttribute('playing')
		  }

		  get muted() {
		    return this.hasAttribute('muted')
		  }

		  get posterElement() {
		    return this.querySelector('[id^="Deferred-Poster-"]')
		  }

		  get controlElement() {
		    return this.querySelector('.media__control-button')
		  }

		  get soundElement() {
		    return this.querySelector('.media__sound-button')
		  }

		  get controlledElement() {
		    return this.hasAttribute('aria-controls') ? document.getElementById(this.getAttribute('aria-controls')) : null
		  }

		  get player() {
		    return this.playerProxy = this.playerProxy || new Proxy(this.playerTarget(), {
		      get: (target, prop) => {
		        return async () => {
		          target = await target;
		          this.playerHandler(target, prop);
		        };
		      }
		    });
		  }

		  createObserver(options) {
			  const threshold = options.threshold ? options.threshold : 0;
			  const observer = new IntersectionObserver((entries, observer) => {
			    entries.forEach(entry => {
			      if (entry.isIntersecting) {
			        if (typeof options.callback === 'function') {
			          options.callback();
			          observer.unobserve(entry.target);
			        }
			      }
			    });
			  }, { rootMargin: `0px 0px ${threshold}px 0px` });
			  observer.observe(options.element);
			}

		  init() {
		    if (this.autoplay) if (!this.paused) this.play();
		  }

		  onPosterClick(event) {
		    event.preventDefault();
		    event.stopPropagation();
		    if (this.playing) {
		      this.paused = true;
		      this.pause();
		    } else {
		      this.paused = false;
		      this.play();
		    }
		    this.updateControlButton(this.paused);
		  }

		  togglePlayPause(event) {
		    event.preventDefault();
		    event.stopPropagation();
		    if (this.playing) {
		      this.paused = true;
		      this.pause();
		    } else {
		      this.paused = false;
		      this.play();
		    }
		    this.updateControlButton(this.paused);
		  }

		  toggleSound(event) {
		    event.preventDefault();
		    event.stopPropagation();
		    if (this.muted) {
		      this.soundOn();
		    } else {
		      this.soundOff();
		    }
		    this.updateSoundButton(this.muted);
		  }

		  attributeChangedCallback(name, oldValue, newValue) {
		    if (name === 'playing') {
		      if (oldValue === null && newValue === '') {
		        this.dispatchEvent(new CustomEvent('video:play', { bubbles: true }));
		        this.paused = false;
		        this.updateControlButton(this.paused);
		      } else if (newValue === null) {
		        this.dispatchEvent(new CustomEvent('video:pause', { bubbles: true }));
		        this.paused = true;
		        this.updateControlButton(this.paused);
		      }
		    }
		  }

		  play() {
		    if (!this.playing) this.player.play();
		  }

		  pause() {
		    if (this.playing) this.player.pause();
		  }

		  soundOff() {
		    if (!this.muted) this.player.muted();
		  }

		  soundOn() {
		    if (this.muted) this.player.unmuted();
		  }

		  updateControlButton(paused = false) {
		    this.controlElement?.classList.toggle('is-pause', paused);
		    this.controlElement?.classList.toggle('is-play', !paused);
		  }

		  updateSoundButton(muted = false) {
		    this.soundElement?.classList.toggle('is-unmuted', muted);
		    this.soundElement?.classList.toggle('is-muted', !muted);
		  }

		  playerTarget() {
		    if (this.hasAttribute('host')) {
		      this.setAttribute('loaded', '');
		      this.classList.remove('loading');
		      return new Promise(async (resolve) => {
		        const templateElement = this.querySelector('template');
		        if (templateElement) templateElement.replaceWith(templateElement.content.firstElementChild.cloneNode(true));
		        const muteVideo = this.hasAttribute('autoplay') || window.matchMedia('screen and (max-width: 1032px)').matches;
		        const script = document.createElement('script');
		        script.type = 'text/javascript';
		        if (this.getAttribute('host') === 'youtube') {
		          if (!window.YT || !window.YT.Player) {
		            script.src = 'https://www.youtube.com/iframe_api';
		            document.head.appendChild(script);
		            await new Promise((resolve2) => script.onload = resolve2);
		          }
		          await onYouTubePromise;
		          const player = new YT.Player(this.querySelector('iframe'), {
		            events: {
		              onReady: () => {
		                if (muteVideo) {
		                  player.mute();
		                  this.setAttribute('muted', '');
		                }
		                resolve(player);
		              },
		              onStateChange: (event) => {
		                if (event.data === YT.PlayerState.PLAYING) {
		                  this.setAttribute('playing', '');
		                } else if (event.data === YT.PlayerState.ENDED || event.data === YT.PlayerState.PAUSED) {
		                  this.removeAttribute('playing');
		                  if (event.data === YT.PlayerState.ENDED) {
		                    this.dispatchEvent(new CustomEvent('video:ended', { bubbles: true }));
		                  }
		                }
		                if (player.isMuted()) {
		                  this.setAttribute('muted', '');
		                } else {
		                  this.removeAttribute('muted');
		                }
		              }
		            }
		          });
		        }
		        if (this.getAttribute('host') === 'vimeo') {
		          if (!window.Vimeo || !window.Vimeo.Player) {
		            script.src = 'https://player.vimeo.com/api/player.js';
		            document.head.appendChild(script);
		            await new Promise((resolve2) => script.onload = resolve2);
		          }
		          const player = new Vimeo.Player(this.querySelector('iframe'));
		          if (muteVideo) {
		            player.setMuted(true);
		            this.setAttribute('muted', '');
		          }
		          player.on('play', () => this.setAttribute('playing', ''));
		          player.on('pause', () => this.removeAttribute('playing'));
		          player.on('ended', () => {
		            this.removeAttribute('playing');
		            this.dispatchEvent(new CustomEvent('video:ended', { bubbles: true }));
		          });
		          player.on('volumechange', () => {
		            if (player.muted) {
		              this.setAttribute('muted', '');
		            } else {
		              this.removeAttribute('muted');
		            }
		          });
		          resolve(player);
		        }
		      });
		    } else {
		      const templateElement = this.querySelector('template');
		      if (templateElement) templateElement.replaceWith(templateElement.content.firstElementChild.cloneNode(true));
		      this.setAttribute('loaded', '');
		      this.classList.remove('loading');
		      const player = this.querySelector('video');
		      if (player.muted) this.setAttribute('muted', '');
		      // Apply necessary attributes for Mobile Safari
		      player.setAttribute('playsinline', '');
		      player.setAttribute('preload', 'auto');
		      // Preload immediately
		      player.load();
		      // Force autoplay for Safari/iOS
		      if (player.muted && player.autoplay) {
		        const tryPlay = player.play();
		        if (tryPlay && typeof tryPlay.catch === 'function') {
		          tryPlay.catch(() => {
		            this.setAttribute('suspended', '');
		            // player.controls = true;
		          });
		        }
		      }
		      player.addEventListener('play', () => {
		        this.setAttribute('playing', '');
		        this.removeAttribute('suspended');
		      });
		      player.addEventListener('pause', () => {
		        if (!player.seeking && player.paused) {
		          this.removeAttribute('playing');
		        }
		      });
		      player.addEventListener('volumechange', () => {
		        if (player.muted) {
		          this.setAttribute('muted', '');
		        } else {
		          this.removeAttribute('muted');
		        }
		      });
		      const handleEnd = () => {
		        this.dispatchEvent(new CustomEvent('video:ended', { bubbles: true }));
		      };
		      const setupLoopDetection = () => {
		        const onTimeUpdate = () => {
		          const duration = player.duration;
		          if (!isNaN(duration) && player.currentTime >= duration - 0.3) {
		            player.removeEventListener('timeupdate', onTimeUpdate);
		            handleEnd();
		          }
		        };
		        player.addEventListener('timeupdate', onTimeUpdate);
		      };
		      if (player.loop) {
		        if (isNaN(player.duration)) {
		          player.addEventListener('loadedmetadata', setupLoopDetection, { once: true });
		        } else {
		          setupLoopDetection();
		        }
		      } else {
		        player.addEventListener('ended', handleEnd);
		      }
		      return player;
		    }
		  }

		  playerHandler(target, prop) {
		    if (this.getAttribute('host') === 'youtube') {
		      prop === 'play' ? target.playVideo() : target.pauseVideo();
		    } else {
		      if (prop === 'play' && !this.hasAttribute('host')) {
		        target.play().catch((error) => {
		          if (error.name === 'NotAllowedError') {
		            this.setAttribute('suspended', '');
		            target.controls = true;
		          }
		        });
		      } else if (prop === 'muted' && !this.hasAttribute('host')) {
		        target.muted = true;
		      } else if (prop === 'unmuted' && !this.hasAttribute('host')) {
		        target.muted = false;
		      } else {
		        target[prop]();
		      }
		    }
		  }
    }
  );
}